import * as React from 'react'

import { Box, Button, Text, useToggle } from '@factorialco/deprecated-design-system'
import { OwnersSectionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import NewOwnerModal from './NewOwnerModal'
import { OwnersList } from './OwnersList'

interface Props {
  owners: Array<OwnersSectionFragment>
}

const OwnersSection = ({ owners }: Props) => {
  const [open, toggle] = useToggle()

  return (
    <Box gap="s32">
      <Box gap="s16">
        <Text size="300" color="grey1000" weight="semibold">
          {i18n.t('performance_process.reviews.basic_information_section.owners.title')}
        </Text>
        <Text.Normal size="200">
          {i18n.t('performance_process.reviews.basic_information_section.owners.description')}
        </Text.Normal>
      </Box>
      <OwnersList owners={owners} />
      <Box justifyContent="flexEnd" flexDirection="row" width="full">
        <Button type="primary" onClick={toggle(!open)} iconName="add">
          {i18n.t('performance_process.reviews.basic_information_section.owners.add_owner')}
        </Button>
      </Box>
      {open && <NewOwnerModal owners={owners} onClose={toggle(!open)} />}
    </Box>
  )
}

export default OwnersSection
